import Product from "components/common/product-thumb"
import Products from "components/common/products"

const debug = require("debug")("lacinetek:debug:selection")

export default ({selection, loading}) => {
	return (
		<section>
			{ selection.products.items.length > 0
				? <Products products={selection.products.items} loading={loading}>
						{products => {
							/**
							 * Précédemment, nous écartions les produits dont le paramètre `available` n'était pas égal à `true`.
							 * Nous ajoutons ce debug pour pouvoir tout de même vérifier ces valeurs car nous ne comprenons pas
							 * forcément pourquoi ces valeurs sont dans cet état dans certains cas (voir carte
							 * [#2754](https://trello.com/c/0vryDYSs/2754-focus-bac-cin%C3%A9ma-audiovisuel-2026-mal-affich%C3%A9)).
							 *
							 * Il n'y a toutefois pas de raison d'écarter ces produits.
							 */
							debug(products.map(({ id, available, name }) => ({
								id,
								name,
								available
							})))

							if (products.length == 0) {
								return null
							}

							return (
								<ul className="grid films">
									{ products.map(product => (
											<Product key={product.id} product={product} loading={loading} />
									))}
								</ul>
							)
						}}
					</Products>
				: null
			}
			{ selection.children.items.map((category, index) => {
					if (category.products.items.length == 0) return null

					return (
						<Products key={`product-${index}`} products={category.products.items} loading={loading}>
							{ products => {
								const selectionProducts = products.filter(p => p.available)
								if (selectionProducts.length == 0) return null

								return (
									<>
										<h3 className="section-title">{category.name}</h3>
										<ul className="grid films">
											{ selectionProducts.map(product => (
												<Product product={product} loading={loading} />
											))}
										</ul>
									</>
								)
							}}
						</Products>
					)
			})}
		</section>
	)
}
